import Vue from 'vue';
import Router from 'vue-router';
import Routers from '../Routers.vue';

Vue.use(Router);

const router = new Router({
  routes: [{
    path: '/',
    component: Routers,
  }],


});

export default router;
